<template>
  <span>
    <button v-if="!hideButton" class="icon-btn" @click="showDownloadModal()">
      <font-awesome-icon icon="cloud-download-alt"/>
    </button>


    <!-- Create the ZIP of all attachments; it is created in the background and downloaded from Export center -->
    <b-modal ref="download-modal"
             modal-class="v2-modal"
             @hide="hideDownloadModal"
    >
      <template #modal-header>
        <div class="v2-modal__head">
          <div class="v2-modal__titles">
            <div class="v2-modal__eyebrow">{{ activity.title }}</div>
            <h3 qid="create-zip-title">{{ $t('reports.create_zip_title') }}</h3>
          </div>
          <span class="task-panel__nav" @click="hideDownloadModal" data-qid="create-zip-close"><font-awesome-icon icon="times"/></span>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <p class="mb-0">{{ $t('reports.create_zip_text') }}</p>
      <p v-if="hasExport" class="text-muted mt-2 mb-0">{{ $t('reports.create_zip_replaces') }}</p>

      <template #modal-footer>
        <div class="v2-modal__footer">
          <b-button variant="secondary"
                    @click="hideDownloadModal"
                    qid="create-zip-cancel-button"
          >
            {{ $t('administration.users.create.cancel') }}
          </b-button>
          <b-button @click="downloadProcessOverviewFile()"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-zip-submit-button"
          >
            <font-awesome-icon icon="file-download" class="mr-1"/>{{ $t('reports.create_zip') }}
          </b-button>
        </div>
      </template>
    </b-modal>


  </span>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'DownloadAllAttachmentsModal',
    data: function() {
      return {

        activity: {},
        sTableItems: [],
        selectedS: [],
        viewSModal: false,
        sLoading: true,

        DOItems: [],
        tasks: [],
        selectedTask: [],

        error: '',
        itemToDelete: {},
        buttonDisabled: false,

        selectedFiles: [],
        inputLink: '',
        inputLinkName: '',
        showDocuments: false,
        selectedImpact: [],
        scopeItems: [],
        selectedScope: []
      }
    },
    props: {
      object: {},
      // The parent opens the modal with showDownloadModal()
      hideButton: {
        type: Boolean,
        default: false
      },
      // A ZIP was created before; a new one replaces it
      hasExport: {
        type: Boolean,
        default: false
      }
    },
    components: {
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      },
      object: function (value) {
        this.activity = value;
      }
    },
    methods: {
      showDownloadModal() {
        this.$refs['download-modal'].show()
      },
      hideDownloadModal() {
        this.error = ''
        this.$refs['download-modal'].hide()
      },
      downloadProcessOverviewFile(){
        //this.successMessage = ''
        let self = this;

        this.buttonDisabled = true;
        piincHttp.get('projects/'+this.activity.slug+'/download-attachments').then(function(response) {
          self.buttonDisabled = false;
          if (response.status == 200) {
            self.$toastr('success', self.$t('reports.create_zip_success'))
          }
          self.$refs['download-modal'].hide()
        }, function() {
          self.buttonDisabled = false;
          self.error = self.$t('reports.something_went_wrong');
        });
      }
    },
    created () {
      this.activity = this.object;
      if (this.getClient && this.getClient.slug) {

      }

    }
  }
</script>
